import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron_mob",
  "use": "chevron_mob-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" id=\"chevron_mob\"><path d=\"M10.45.5L5.5 5.45.55.5\" stroke-width=\"1.5\" stroke=\"#9F9F9F\" fill=\"none\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol